export const stripePrice = Number(
  import.meta.env.VITE_APP_STRIPE_PRICE as string,
);

export const stripeCurrency = import.meta.env
  .VITE_APP_STRIPE_CURRENCY as string;

export const stripePriceFormatted = (stripePrice / 100).toLocaleString(
  "pl-PL",
  {
    style: "currency",
    currency: stripeCurrency,
  },
);
